import { track } from "jiffy-analytics";
import * as flag from "common/utils/flag";
import EventClass from "common/utils/ui/event-class";
import "./digital-assets-promo-banner.scss";

export class DigitalAssetsPromoBannerCloseButton extends EventClass {
  #flagName = "__JIFFY__DIGITAL_CTA_PDP_CLOSED__";

  #digitalAssetsPromoBannerSelector = ".js-digital-assets-promo-banner";

  get $digitalAssetsPromoBanner() {
    return document.querySelector(this.#digitalAssetsPromoBannerSelector);
  }

  event() {
    this.$digitalAssetsPromoBanner?.classList.add("hidden");
    track("digital_cta_closed", { page: "pdp" });
    flag.toggle(this.#flagName);
  }

  init() {
    if (flag.isOn(this.#flagName)) return;
    this.$digitalAssetsPromoBanner?.classList.remove("hidden");
  }
}

export default () =>
  new DigitalAssetsPromoBannerCloseButton({
    eventSelector: ".js-digital-assets-promo-banner-close"
  });
